



import { Component, Vue, Prop } from 'vue-property-decorator'
import { IUser } from '@/features/auth/store'
@Component
export default class User extends Vue {
  @Prop()
  readonly user!: IUser
}
